import { useEffect, useRef, useState } from "react";
import { T } from "react-translator-component";

interface Props {
  text: string;
  lineHeight: number;
  maxLines?: number;
  width: number;
}

const SeeMoreText = ({ text, lineHeight, maxLines = 2, width }: Props) => {
  const textRef = useRef<HTMLDivElement>(null)
  const measureRef = useRef<HTMLDivElement>(null)
  const [displayText, setDisplayText] = useState<string>(text)
  const [showSeeMore, setShowSeeMore] = useState<boolean>(false)
  const [isMeasured, setIsMeasured] = useState<boolean>(false)

  const seeMoreText = `${T("see_more_text")}`

  useEffect(() => {
    const measureElement = measureRef.current
    if (!measureElement) return

    const maxHeight = lineHeight * maxLines

    let formatText = ""
    let end = 0
    let isOverText = false

    measureElement.innerHTML = `${text}`

    isOverText = measureElement.offsetHeight > maxHeight

    if (isOverText) {
      while (end <= text.length) {
        const sliceText = text.slice(0, end)

        measureElement.innerHTML = `${sliceText}<span>${seeMoreText}</span>`

        end += 1
        if (measureElement.offsetHeight <= maxHeight) {
          formatText = sliceText
        } else {
          break
        }
      }
    } else {
      formatText = `${text}`
    }

    setDisplayText(formatText)
    setShowSeeMore(end > 0 ? end <= text.length : false)
    setIsMeasured(true)
  }, [text])

  useEffect(() => {
    if (!isMeasured) return

    const measureElement = measureRef.current
    if (!measureElement) return

    measureElement.style.height = "0"
  }, [isMeasured])

  const handleClickOpen = () => {
    setShowSeeMore(false)
    setDisplayText(text)

    const textContainer = textRef.current
    if (!textContainer) return
    textContainer.style.overflow = ""
    textContainer.style.maxHeight = ""
  }

  return (
    <>
      <div
        ref={textRef}
        style={{
          lineHeight: `${lineHeight}px`,
          maxHeight: `${lineHeight * maxLines}px`,
          overflow: "hidden",
          width: `${width}px`
        }}
      >
        {displayText}
        {showSeeMore && (
          <span
            style={{
              color: "gray",
            }}
            onClick={handleClickOpen}
          >
            {seeMoreText}
          </span>
        )}
      </div>

      {/* 描画計測用の要素 */}
      <div
        ref={measureRef}
        style={{
          visibility: "hidden",
          lineHeight: `${lineHeight}px`,
          width: `${width}px`,
        }}
      >
      </div>
    </>
  )
}

export default SeeMoreText
